<template>
  <div>
    <input type="checkbox" />
    {{ number }} {{ option.label }}
    <Img v-for="(image, key) in option.images" :key="key" :url="image.url" :data="image.data" />
  </div>
</template>

<script>
  import Img from './Img'

  export default {
    data () {
      return {}
    },

    props: [ 'number', 'option' ],

    computed: {
      value: {
        get () {

        },
        set () {

        }
      }
    },

    components: {
      Img
    }
  }
</script>
